var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48973 0H12.5103C13.3333 0 14 0.686737 14 1.53458V2.60663C14 3.01793 13.8393 3.4129 13.5539 3.70095L9.00036 8.30692C8.9218 8.3871 8.81514 8.43164 8.70486 8.4309L4.89225 8.41902C4.77622 8.41902 4.66595 8.36928 4.58667 8.28242L0.402162 3.68017C0.143423 3.39582 0 3.02016 0 2.63039V1.53532C0 0.687479 0.666667 0 1.48973 0ZM5.09691 9.67689L8.49511 9.68729C8.707 9.68803 8.87854 9.86547 8.87854 10.083V11.9947C8.87854 12.213 8.75457 12.4105 8.56142 12.5018L5.47673 13.9502C5.40466 13.9837 5.32827 14 5.25187 14C5.15025 14 5.04863 13.9703 4.95998 13.9116C4.80502 13.8092 4.71133 13.6325 4.71133 13.4432V10.0726C4.71133 9.85359 4.8843 9.67615 5.09691 9.67689Z",
    fill: "#C1CAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.7a394309.svg";
export { ForwardRef as ReactComponent };